import { Controller } from "@hotwired/stimulus"

// Handles active link state for turbo-permanent navbar and sidebar.
// Since permanent elements skip server re-rendering, we update active
// classes client-side on every Turbo navigation.
export default class extends Controller {
  connect() {
    this.update()
    document.addEventListener("turbo:load", this.update)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.update)
  }

  update = () => {
    const path = window.location.pathname

    // Navbar links
    const navbar = document.getElementById("main-navbar")
    if (navbar) {
      navbar.querySelectorAll("a[href]").forEach(link => {
        if (!this.isNavLink(link)) return
        const active = this.isActive(link.pathname, path)
        link.classList.toggle("font-medium", active)
        link.classList.toggle("text-gray-900", active)
        // dark:text-white is a single class token in Tailwind
        link.classList.toggle("dark:text-white", active)
      })
    }

    // Sidebar links
    const sidebar = document.getElementById("main-sidebar")
    if (sidebar) {
      sidebar.querySelectorAll("a[href]").forEach(link => {
        const active = this.isActive(link.pathname, path)
        if (active) {
          link.classList.remove("sidebar-link")
          link.classList.add("sidebar-link-active")
        } else {
          link.classList.remove("sidebar-link-active")
          link.classList.add("sidebar-link")
        }
      })
    }
  }

  // Only target the top nav links (not logo, dropdown items, etc.)
  isNavLink(link) {
    return link.closest(".lg\\:flex.items-center.gap-6") !== null
  }

  isActive(linkPath, currentPath) {
    if (linkPath === "/") return currentPath === "/"
    return currentPath === linkPath || currentPath.startsWith(linkPath + "/")
  }
}
